import React, { FC, PropsWithChildren } from 'react';
import styles from './commonBackground.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface Props {
  isGreen?: boolean;
  isGray?: boolean;
}

export const CommonBackground: FC<PropsWithChildren<Props>> = (props) => {
  const { isGray, isGreen, children } = props;
  return <div className={cx('background')}>{children}</div>;
};
